import { supabase } from '../supabase'
import type { Sport, GroupedSports } from '@/lib/types/sport'
import { APP_CONSTANTS } from '@/lib/constants/app'

export const sportsRepository = {
  async fetchActiveSports(): Promise<Sport[]> {
    const { data, error } = await supabase
      .from('sports')
      .select('*')
      .eq('is_active', true)
      .eq('is_booked', false)
      .order('category')
      .order('name')

    if (error) throw new Error(`Failed to fetch sports: ${error.message}`)
    return data as Sport[]
  },

  groupSportsByCategory(sports: Sport[]): GroupedSports {
    const grouped: GroupedSports = {}

    sports.forEach((sport) => {
      if (!grouped[sport.category]) {
        grouped[sport.category] = []
      }
      grouped[sport.category].push(sport)
    })

    // Sort by category order
    const sorted: GroupedSports = {}
    APP_CONSTANTS.SPORT_CATEGORIES_ORDER.forEach((category) => {
      if (grouped[category]) {
        sorted[category] = grouped[category]
      }
    })

    // Add remaining categories not in predefined order
    Object.entries(grouped).forEach(([category, categorySports]) => {
      if (!APP_CONSTANTS.SPORT_CATEGORIES_ORDER.includes(category as any)) {
        sorted[category] = categorySports
      }
    })

    return sorted
  },
}
